import React from "react";
import { Link } from "react-router-dom";
import { hasRole } from "../../utils/auth";

// Role-based route guard. App.js already gates on authentication (no user -> Auth
// screen), so this only validates that the logged-in user holds one of the
// required roles before rendering a sensitive screen. On mismatch we render a
// 403 instead of the screen — the user cannot reach the protected content.
//
// Backend (mohtaj-api) enforces the same gate server-side regardless; this is
// defence-in-depth on the client (MOH-394 frontend split / finding F-mohtaj-admin-03).
const Forbidden = () => (
  <div className="m-5 flex flex-column align-items-center justify-content-center gap-3 text-center">
    <i className="pi pi-lock" style={{ fontSize: "3rem", color: "#C93B32" }} />
    <h2 className="m-0 text-2xl font-bold">403 — Access denied</h2>
    <p className="m-0 text-gray-500">
      This area is restricted to Super Admin users.
    </p>
    <Link
      to="/dashboard"
      className="rounded-full bg-[#3D5FD9] text-[#F5F7FF] px-5 py-2 mt-2 hover:bg-[#2347C5]"
    >
      Back to Dashboard
    </Link>
  </div>
);

const ProtectedRoute = ({ requiredRoles, children }) => {
  if (hasRole(requiredRoles)) return children;
  return <Forbidden />;
};

export default ProtectedRoute;
